import _ from "lodash";
import * as types from "../types/rlab-types";

const defaultState = {
  generating: false,
  variants: {},
  // Campaigns allocated on the most recent request. Consumers that need to react
  // to a brand new assignment (rather than just read the variant) watch this.
  newlyGenerated: []
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.GENERATE_VARIANTS_RESET:
      return Object.assign({}, state, {
        generating: false,
        newlyGenerated: []
      });
    case types.GENERATE_VARIANTS_PENDING:
      return Object.assign({}, state, {
        generating: true
      });
    case types.GENERATE_VARIANTS_FAILURE:
      return Object.assign({}, state, {
        generating: false
      });
    case types.GENERATE_VARIANTS_SUCCESS:
      // Accepts both the nested { variants, generated } payload and the older flat
      // campaign->variant map for backward compatibility
      const payload = action.res || {};
      const variants = Object.assign(
        {},
        state.variants,
        payload.variants || _.omit(payload, ["generated"])
      );
      const newlyGenerated = Array.isArray(payload.generated) ? payload.generated : [];
      return Object.assign({}, state, {
        generating: false,
        variants,
        newlyGenerated
      });
    default:
      return state;
  }
};

export default reducer;
